import Axios from 'axios';

const baseEndpoint: string = window.eurofarmaService.base;

class ConfigurationService {

    static getConfiguration = async (key: string) => {
        var md5 = require('md5');
        key = md5(key);
        var retorno =  await Axios.get(`${baseEndpoint}${window.eurofarmaService.configuration}/${key}`);

        return retorno.data.data;
    }
}

export default ConfigurationService;